import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useScrollReveal } from '../utils/ScrollReveal';
import CarSwiper from '../utils/Swiper';
import ServiciosHome from '../utils/ServiciosHome';
import './Home.css'; // Import the new CSS file

const Home = () => {
    useScrollReveal();

    return (
        <div>
            <Helmet>
                <title>Manacars | Concesionario multimarca en Oyón (Álava)</title>
                <meta name="description" content="Coches de ocasión y km 0 en Oyón, cerca de Logroño. Financiación a medida y garantía de 12 meses. Entrega en toda España." />
                <link rel="canonical" href="https://manacars.es" />
            </Helmet>
            <main className="main">

                <section className="home section" id="home">
                    <div className="shape shape__big"></div>
                    <div className="shape shape__small"></div>

                    <div className="home__container container grid">
                        <div className="home__data">
                        </div>

                        <div className="home__cover-container">
                            {/* The background image will be set via CSS on home__cover-container */}
                            <img src="img/ManaCars_Logo_V1/SVG/Manna Logo_Mesa de trabajo 1.svg" alt="ManaCars Logo" className="home__logo-overlay"/>
                        </div>
                    </div>
                </section>

        
                <section className="about section" id="about">
                    <div className="about__container container grid">
                        <div className="about__group">
                            <picture>
                                <source srcSet="img/about.webp" type="image/webp" />
                                <img src="img/about.png" alt="Coche deportivo en exposición" className="about__img"/>
                            </picture>

                            <div className="about__card">
                                <h3 className="about__card-title">100+</h3>
                                <p className="about__card-description">
                                    Más de 100 coches vendidos
                                </p>
                            </div>
                        </div>

                        <div className="about__data">
                            <h2 className="section__title about__title">
                                MANACARS <br/> Motors
                            </h2>

                            <p className="about__description">
                                En Manacars somos un concesionario multimarca especializado en vehículos de ocasión y km 0. Revisamos cada coche antes de ponerlo a la venta, ofrecemos financiación a medida y garantía incluida en todos nuestros vehículos. Estamos en Oyón (Álava), a solo 3 km de Logroño, y hacemos entregas en toda España.
                            </p>

                            <a href="/about" className="button">Saber más</a>
                        </div>
                    </div>
                </section>
                <CarSwiper/>
                <ServiciosHome />
                <section className="offer section">
                    <div className="offer__container container grid">
                        <div className="offer__data">
                            <h2 className="offer__title">
                                Quieres recibir una <br/>tasación de tu coche?
                            </h2>

                            <p className="offer__description">
                                Rellena el formulario y recibe toda la información
                                en tu correo email.
                            </p>

                            <a href="/tasación" className="button">
                                Rellenar formulario
                            </a>
                        </div>

                        <picture>
                            <source srcSet="img/offer.webp" type="image/webp" />
                            <img src="img/offer.png" alt="Oferta especial de coche" className="offer__img"/>
                        </picture>
                    </div>
                </section>
                <section className="logos section">
                    <div className="logos__container container grid">
                        <div className="logos__content">
                            <img src="img/BMW123.png" alt="" className="logos__img"/>
                        </div>

                        <div className="logos__content">
                            <img src="img/BMW123.png" alt="" className="logos__img"/>
                        </div>

                        <div className="logos__content">
                            <img src="img/BMW123.png" alt="" className="logos__img"/>
                        </div>

                        <div className="logos__content">
                            <img src="img/BMW123.png" alt="" className="logos__img"/>
                        </div>

                        <div className="logos__content">
                            <img src="img/BMW123.png" alt="" className="logos__img"/>
                        </div>

                        <div className="logos__content">
                            <img src="img/BMW123.png" alt="" className="logos__img"/>
                        </div>
                    </div>
                </section>
                
            </main>
        </div>
    )
}
export default Home;